import React, { useState } from 'react';
import Card from '@/components/card';
import Title from '@/components/title';
import { settingMenu } from '@/configs/menuItems';
import SubMenu from '@/components/menu/sub-menu';
import { Space, Table } from 'antd';
import type { TableProps } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getPathSegment } from '@/utils/pathUtils';
import { queryExchangeRates } from '@/adapters/setting';
import {
  IExchangeRate,
  ISearchExchangeRateReq,
  ISearchExchangeRateRes,
} from '@/interfaces/setting';
import { formatDate, formatNumber } from '@/utils/dataUtils';

const _criteria: ISearchExchangeRateReq = {
  orderBy: 'id',
  orderType: 'descend',
  pageSize: -1,
  pageStart: 1,
};

const ExchangeRate = () => {
  const pathSegment = getPathSegment();

  const [criteria] = useState<ISearchExchangeRateReq>({
    ..._criteria,
  });

  const { data: exchange } = useQuery<
    AxiosResponse<ISearchExchangeRateRes>,
    Error
  >({
    queryKey: ['exchange-rate'],
    queryFn: async () => await queryExchangeRates(criteria),
  });

  const columns: TableProps<IExchangeRate>['columns'] = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 40,
      className: 'text-center',
      fixed: 'left',
      render: (_, rec, i) => <Space>{i + 1}</Space>,
    },
    {
      title: 'Currency',
      dataIndex: 'currency',
      key: 'currency',
      className: 'font-bold',
    },
    {
      title: 'Update Date',
      dataIndex: 'createDate',
      key: 'createDate',
      className: 'font-bold',
      render: _ => formatDate(_),
    },
    {
      title: 'Update By',
      dataIndex: 'createByName',
      key: 'createByName',
      className: 'font-bold',
    },
    {
      title: 'RATE',
      dataIndex: 'rate',
      key: 'rate',
      className: 'font-bold',
      render: _ => formatNumber(_, 4),
    },
  ];

  return (
    <>
      <SubMenu active={pathSegment} items={settingMenu} />
      <Card>
        <Title title="Exchange Rate"></Title>
        <div className="flex flex-col gap-3">
          <Table
            loading={false}
            columns={columns}
            dataSource={exchange?.data?.data || []}
            size="small"
            bordered
            className="font-ibm"
          />
        </div>
      </Card>
    </>
  );
};

export default ExchangeRate;
